import { useEffect, useState } from 'react'

const useDebounce = () => {

    // Dodajemy uniwersalny hook `useDebounce`
    // Będzie on opóźniał aktualizację wartości filtra
    //Ten do obiektów złożonych jak obiekty i tablice
    function useDebounceWithStrongValueCheck(value, delay) {
        const [debouncedValue, setDebouncedValue] = useState(value)
        useEffect(() => {
            const handler = setTimeout(() => {
                setDebouncedValue(value)
            }, delay)

            return () => {
                clearTimeout(handler)
            }
        }, [JSON.stringify(value), delay]) // Używamy stringify dla głębokiego porównania obiektu
        return debouncedValue
    }

    // Ten do prostych wartości jak stringi i liczby
    function useDebounceWithStandardValueCheck(value, delay) {
        const [debouncedValue, setDebouncedValue] = useState(value)
        useEffect(() => {
            const handler = setTimeout(() => {
                setDebouncedValue(value)
            }, delay)

            return () => {
                clearTimeout(handler)
            }
        }, [value, delay])
        return debouncedValue
    }

    return { useDebounceWithStrongValueCheck, useDebounceWithStandardValueCheck }
}

export default useDebounce